





define(['services/utils', './helpers/getRouteFeature'], function(Utils, getRouteFeature) {
    'use strict';

    function newFeatureCollection() {
        return {
            type: 'FeatureCollection',
            features: []
        };
    }

    return function(data) {
        var result, i;
        if (Utils.isString(data)) {
            try {
                data = JSON.parse(data); // aja js has problems and response is not always parsed as it should
            } catch (e) {
                return null;
            }
        }
        if (data.error) {
            return { error: data.error};
        } else {
            result = newFeatureCollection();
            result.optimizedWaypoints = data.optimizedWaypoints;
            if (!data || !data.routes) {
                return result;
            }
            for (i = 0; i < data.routes.length; i += 1) {
                result.features.push(getRouteFeature(data.routes[i]));
            }
            return result;
        }
    };
});



// WEBPACK FOOTER //
// ./model/routing/routing.js